<template>
  <div class="topic_banner">
    <span class="prevBtn" @click="prev">
      <img src="http://hfy-img.xzyunchuang.com/90df8169c433f7c1925333e15e204929"/>
    </span>
    <section class="pc-banner">
      <div class="swiper-container">
        <div class="swiper-wrapper" style="display: flex;align-items: center;">
          <!-- <div class="swiper-slide swiper-slide-center none-effect">
                   </div> -->
          <div class="swiper-slide" v-for="(item, index) in topicData" :key="index">
            <div :data-id="item.id" :class="('item'+index)">
              <p class="swiper-slide-img"><img :src="item.listUrl" :alt="item.specialName"></p>
              <p class="overh overf">{{item.specialName }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination"></div>
      <!-- 如果需要导航按钮 -->
      <!-- <div class="swiper-button-prev"></div>
           <div class="swiper-button-next"></div> -->
    </section>
    <span class="nextBtn" @click="nexts">
      <img src="http://hfy-img.xzyunchuang.com/e873219c88077aa1569b78ec2a9c3237"/>
    </span>
  </div>
</template>

<script>
import Swiper from 'swiper'
// import 'swiper/css/swiper.css'
// import 'swiper/dist/css/swiper.css'
// import 'swiper/dist/css/swiper.min.css'
import 'swiper/swiper-bundle.css'
// import {
//   topTopic//专题推荐
// } from "@/api/index.js";
export default {
  props:{
    topicData: {
      type: [Object,Array],
      default:[]
    }
  },
  data() {
    return {
      list:[],
      swiper: ''
    }
  },
  created(){

  },
  mounted() {
    var that =this;
    setTimeout(function(){
      that.Lunbo()
    },500)
    
    // this. topicData()
  },
  methods: {
    // topicData(){
    //   topTopic({}).then(res => {
    //     this.topicList = res.data;
       
    //   })
    // },
    goItem(e){
      console.log(e)
      let cardData = e.target.dataset
      console.log(cardData)
      // console.log(this.swiper.activeIndex);
      // console.log(i)
    },
    prev() {
      this.swiper.slidePrev();
    },
    nexts() {
      this.swiper.slideNext()
    },
    Lunbo() {
      var that = this;
      this.swiper = new Swiper('.swiper-container', {
        slidesPerView: 4.5,
        spaceBetween: 8,
        loop: true,
        speed: 2000,
        autoplay: true,
        // autoplayDisableOnInteraction: false,
        // disableOnInteraction: true,
        // observer: true,
        // observeParents: true,
        pagination: '.swiper-pagination',
        // paginationClickable: true,
        // mousewheelControl: true,
        debugger: true,
        on: {
          click: function (e) {
            // console.log(e)
            let innerTexts = e.clickedSlide.innerText;
            let t =that.topicData.findIndex(function(item){
              return item.specialName==innerTexts;
            })
            let item =that.topicData[t];
            console.log(item)
            // return;
            if (item.module) {
                window.open('/topList?topic=' + item.id, "_blank");
            } else {
                window.open('/topList1?topic=' + JSON.stringify({topic:item.id}), "_blank");
            }
            // item.specialName
          },
          // slideChange: function () {
          //   var index = this.activeIndex;
          //   console.log('当前位置：', index);
          // }
        }
        // prevButton:'.swiper-button-prev',
        // nextButton:'.swiper-button-next',
        // navigation: {
        //     nextEl: '.swiper-button-next',
        //     prevEl: '.swiper-button-prev',
        // }
      });
      var that = this;
      that.swiper.slideTo(0, 0, false);
      setInterval(function () {
        that.swiper.slideNext()
      }, 2000)
    },
  }
};
</script>
<style lang="scss" scoped>
.topic_banner{
  position: relative;
}
.prevBtn,.nextBtn{
  position: absolute;
  background: #fff;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  z-index: 9999;
  cursor: pointer;
  img{
    width: 10px;
  }
}
.prevBtn{
 
  left: -26px;
  top: 85px;
  
}
.nextBtn{
  right: 3px;
  top: 85px;
}
.pc-banner {
  position: relative;
  width: 1050px;
  padding-right: 10px;
  overflow: hidden;

  .swiper-container {
    width: 90%;
  }

  .button {
    width: 100%;
    display: flex;
    justify-content: space-between;
    position: absolute;
    top: 50%;

    .swiper-button-next {
      color: black;
    }
  }
}

@media only screen and (min-width:1200px) {
  .main {
    background: springgreen;
  }
}

/*最大的宽度是1200px，小于1200px都适用于这里*/
@media only screen and (max-width:960px) {
  .main {
    width: 100%;
  }
}

/*
     大于min-width的宽度，小于max-width宽度
     * */
@media only screen and (min-width: 960px) and (max-width: 1200px) {
  .main {
    width: 100%;
  }
}

.swiper-slide {
  -webkit-transition: transform 1.0s;
  -moz-transition: transform 1.0s;
  -ms-transition: transform 1.0s;
  -o-transition: transform 1.0s;

  // -webkit-transform: scale(0.7);
  // transform: scale(0.7);
}

.overh {
  width: 187px;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  background: #fff;
  cursor: pointer;
  padding: 0 10px;
  border-radius: 0 0 6px 6px;
}


.swiper-slide-active {
  -webkit-transform: scale(1);
  transform: scale(1);
}


.none-effect {
  -webkit-transition: none;
  -moz-transition: none;
  -ms-transition: none;
  -o-transition: none;
}

.swiper-slide {
  width: 204px !important;
  overflow-x: hidden;
  .swiper-slide-img{
    width: 204px;
    height: 136px;
    overflow: hidden;
  }
  img {
    border-radius: 6px 6px 0 0;
    width: 204px;
    height: 136px;
    object-fit: fill;
    cursor: pointer;
    display: block;
  }
  &:hover{
    img{
      transition: all 0.5s linear;
      transform: scale(1.03);
    }
    .overh{
      color: #245488;
    }
   
  }
}

.button {
  width: 100%;
  margin: auto;
  position: relative;
  top: 25%;
}

@media screen and (max-width: 750px) {
  .button {
    width: 100%;
  }
}

.swiper-button-prev {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l4.2%2C4.2L8.4%2C22l17.8%2C17.8L22%2C44L0%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E") #c9c9ca center 50%/50% 50% no-repeat;
}

.swiper-button-next {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L5%2C44l-4.2-4.2L18.6%2C22L0.8%2C4.2L5%2C0z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E") #c9c9ca center 50%/50% 50% no-repeat;
}

@media screen and (max-width: 750px) {
  .button div {
    width: 28px;
    height: 28px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/index/topicIcon.vue